module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/queue-template/queue-template.component.scss
// module id = ./src/app/component/queue-template/queue-template.component.scss
// module chunks = main